import React from 'react';
import { Link } from "gatsby";
import { ReactComponent as Apple } from '/static/images/mega-menu-icons/apple.svg';
import { ReactComponent as Android } from '/static/images/mega-menu-icons/android.svg';
import { ReactComponent as Flutter } from '/static/images/mega-menu-icons/flutter.svg';
import { ReactComponent as ReactNative } from '/static/images/mega-menu-icons/react-native.svg';
import { ReactComponent as Magento } from '/static/images/mega-menu-icons/magento.svg';
import { ReactComponent as Wordpress } from '/static/images/mega-menu-icons/wordpress.svg';
import { ReactComponent as Shopify } from '/static/images/mega-menu-icons/shopify.svg';
import { ReactComponent as WooCommerce } from '/static/images/mega-menu-icons/woo-commerce.svg';
import { ReactComponent as ElectronJs } from '/static/images/mega-menu-icons/electron-jS.svg';
import { ReactComponent as Mean } from '/static/images/mega-menu-icons/mean.svg';
import { ReactComponent as Vue } from '/static/images/mega-menu-icons/vue.svg';
import { ReactComponent as Mern } from '/static/images/mega-menu-icons/mern.svg';
import { ReactComponent as NextJs } from '/static/images/mega-menu-icons/next-js.svg';
import { ReactComponent as NodeJs } from '/static/images/mega-menu-icons/node-js.svg';
import { ReactComponent as AwsDeveloper } from '/static/images/mega-menu-icons/aws-developer.svg';
import { ReactComponent as Lambda } from '/static/images/mega-menu-icons/lambda.svg';
import { ReactComponent as UiUxDesigner } from '/static/images/mega-menu-icons/ui-ux-designer.svg';
import { ReactComponent as WebFlowDesigners } from '/static/images/mega-menu-icons/web-flow-designers.svg';
import { ReactComponent as Angular } from '/static/images/mega-menu-icons/angular.svg';
import { ReactComponent as Laravel } from '/static/images/mega-menu-icons/laravel.svg';
import { ReactComponent as Php } from '/static/images/mega-menu-icons/php.svg';
import { ReactComponent as FrontEndDevelopers } from '/static/images/mega-menu-icons/front-end-developers.svg';
import { ReactComponent as PythonDevelopers } from '/static/images/mega-menu-icons/python-developers.svg';
import { ReactComponent as Qa } from '/static/images/mega-menu-icons/qa.svg';
import { ReactComponent as AutomationQa } from '/static/images/mega-menu-icons/automation-qa.svg';

const HireDevelopersModal = () => {

    return (
        <div className="row">
            <div className="col-md-4">

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Mobile App</span>

                <div className="">
                    <Link to="/hire/ios" className="mega-menu-link">
                        <Apple
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled IOS Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire IOS Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/android" className="mega-menu-link">
                        <Android
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Android Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Android Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/flutter" className="mega-menu-link">
                        <Flutter
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Flutter Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Flutter Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/react-native" className="mega-menu-link">
                        <ReactNative
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Automation Native Developers MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire React Native Developers</span>
                        </div>
                    </Link>
                </div>

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Ecommerce</span>

                <div className="">
                    <Link to="/hire/magento" className="mega-menu-link">
                        <Magento
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Magento Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Magento Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/wordpress" className="mega-menu-link">
                        <Wordpress
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Wordpress Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Wordpress Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/shopify" className="mega-menu-link">
                        <Shopify
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Shopify Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Shopify Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/woo-commerce" className="mega-menu-link">
                        <WooCommerce
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled WooCommerce Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire WooCommerce Developers</span>
                        </div>
                    </Link>
                </div>

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Software Developer</span>

                <div className="">
                    <Link to="/hire/electron-js" className="mega-menu-link">
                        <ElectronJs
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled ElectronJS Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire ElectronJS Developers</span>
                        </div>
                    </Link>
                </div>

            </div>

            <div className="col-md-4">

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Javascript</span>

                <div className="">
                    <Link to="/hire/mean" className="mega-menu-link">
                        <Mean
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled MEAN Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire MEAN Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/vue-js" className="mega-menu-link">
                        <Vue
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Vue Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Vue Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/mern" className="mega-menu-link">
                        <Mern
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled MERN Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire MERN Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/next-js" className="mega-menu-link">
                        <NextJs
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled NextJS Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire NextJS Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/node-js" className="mega-menu-link">
                        <NodeJs
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled NodeJS Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire NodeJS Developers</span>
                        </div>
                    </Link>
                </div>

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Cloud Computing</span>

                <div className="">
                    <Link to="/hire/aws" className="mega-menu-link">
                        <AwsDeveloper
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled AWS Engineers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire AWS Engineers</span>
                        </div>
                    </Link>
                    <Link to="/hire/lambda" className="mega-menu-link">
                        <Lambda
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled AWS Lambda Engineers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire AWS Lambda Engineers</span>
                        </div>
                    </Link>
                </div>

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">UIUX Designer</span>

                <div className="">
                    <Link to="/hire/ui-ux-designers" className="mega-menu-link">
                        <UiUxDesigner
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled UIUX Designer at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire UIUX Designer</span>
                        </div>
                    </Link>
                    <Link to="/hire/webflow" className="mega-menu-link">
                        <WebFlowDesigners
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Frammer/Webflow Designers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Frammer/Webflow Designers</span>
                        </div>
                    </Link>
                </div>

            </div>

            <div className="col-md-4">

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">Web</span>

                <div className="">
                    <Link to="/hire/angular" className="mega-menu-link">
                        <Angular
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Angular Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Angular Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/react-js" className="mega-menu-link">
                        <ReactNative
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled React Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire React Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/laravel" className="mega-menu-link">
                        <Laravel
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Laravel Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Laravel Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/php" className="mega-menu-link">
                        <Php
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled PHP Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire PHP Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/frontend-developers" className="mega-menu-link">
                        <FrontEndDevelopers
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Frontend Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Frontend Developers</span>
                        </div>
                    </Link>
                    <Link to="/hire/python" className="mega-menu-link">
                        <PythonDevelopers
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Python Developers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Python Developers</span>
                        </div>
                    </Link>
                </div>

                <span className="fs-20 ls-minus-05px alt-font text-dark-gray fw-600 mb-10px">QA</span>

                <div className="">
                    <Link to="/hire/qa" className="mega-menu-link">
                        <Qa
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled QA Engineers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire QA Engineers</span>
                        </div>
                    </Link>

                    <Link to="/hire/automation-qa" className="mega-menu-link">
                        <AutomationQa
                            className="w-30px h-30px me-10px hire-developer-modal__icon"
                            alt="Hire skilled Automation Engineers at MatrixBrains Pvt Ltd for your projects."
                        />
                        <div className="submenu-icon-content">
                            <span>Hire Automation Engineers</span>
                        </div>
                    </Link>
                </div>

            </div>

        </div>
    );
};

export default HireDevelopersModal;
